import React from 'react';
import { Link } from 'react-router-dom';
import { pathJoin } from '../../../services/api';
import { timestampToHuman } from '../../../services/formatting';
import { AddAuthorizedUser } from '../../shared/actions/actionButtons';
import { QueryGrid, QueryGridSelectMode } from '../../shared/grid/queryGrid/queryGrid';

import styles from './authorizedUserAuditLog.module.css';

export const AuthorizedUserAuditLog = ({
    systemId,
    ...props
}) => {

    return systemId && <>
        <QueryGrid
            queryParamPrefix='al_'
            singleResourceName='Audit Log'
            pluralResourceName='Audit Logs'
            nameFunction={r => ''}
            restEndpoint={pathJoin('/systemAccess', systemId, 'authorizedUsers', 'auditLogs')}
            listUrl={pathJoin('/systemAccess', systemId)}
            selectMode={QueryGridSelectMode.None}
            maxResults={10}
            actions={[]}
            columns={{
                action: {
                    label: 'Action',
                    formatFunction: r => r.action,
                },
                'target.displayName': {
                    label: 'Target',
                    formatFunction: r => <Link to={pathJoin('/users', r.target.id)}>{r.target.displayName}</Link>,
                },
                'issuer.displayName': {
                    label: 'Issuer',
                    formatFunction: r => <Link to={pathJoin('/users', r.issuer.id)}>{r.issuer.displayName}</Link>,
                },
                timestamp: {
                    label: 'Timestamp',
                    formatFunction: r => timestampToHuman(r.timestamp),
                },
            }}
            {...props}
        />
    </>
}